import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { Modal, Radio, Row } from 'antd'
import Qrcode from 'qrcode.react'
import { RootDispatch } from '../../app/store'
import { ThemeContext } from '../../theme/ThemeContext'
import {
  payStatusAsync,
  QRCodeAsync,
} from '../productCenter/productCenterSlice'

let productTimer: any = null

interface SmsRechargeModalProps {
  visible: boolean
  onCancel: () => void
  onSuccess?: () => void
}

const getUnit = (v: number): string => {
  switch (v) {
    case 0:
      return '年'
    case 1:
      return '天'
    case 2:
      return '次'
    case 3:
      return '个'
    case 4:
      return '1个医生'
    default:
      return '年'
  }
}

export const SmsRechargeModal = ({
  visible,
  onCancel,
  onSuccess,
}: SmsRechargeModalProps): ReactElement => {
  const theme = useContext(ThemeContext)
  const dispatch = useDispatch<RootDispatch>()

  const [payType, setPayType] = useState(1)
  const [loading, setLoading] = useState(false)
  const [payInfo, setPayInfo] = useState<any>({})
  const [qrCodeVisible, setQrCodeVisible] = useState(false)

  const prevVisibleRef = useRef(false)
  const prevPayTypeRef = useRef(1)

  const getQrcode = (currentPayType: number) => {
    const data = {
      payType: currentPayType,
      productId: 14,
      durationNum: 1,
    }
    setLoading(true)
    dispatch(QRCodeAsync(data))
      .then(unwrapResult)
      .then((res: any) => {
        setPayInfo(res)
        res.productName = '短信'
        res.durationUnit = getUnit(3)
        setQrCodeVisible(true)
        productTimer && clearInterval(productTimer)
        setLoading(false)
        productTimer = setInterval(() => {
          dispatch(payStatusAsync(res.orderId))
            .then(unwrapResult)
            .then((payRes: any) => {
              if (payRes.status == 1) {
                setQrCodeVisible(false)
                productTimer && clearInterval(productTimer)
                productTimer = null
                onSuccess?.()
                onCancel()
              }
            })
        }, 1000)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // 每次渲染后检查 visible 和 payType 变化，可靠触发 API 调用
  useEffect(() => {
    // visible 从 false → true：首次打开弹窗
    if (visible && !prevVisibleRef.current) {
      prevVisibleRef.current = true
      prevPayTypeRef.current = payType
      getQrcode(payType)
    }
    // visible 从 true → false：关闭弹窗，重置状态
    if (!visible && prevVisibleRef.current) {
      prevVisibleRef.current = false
      setPayType(1)
      setQrCodeVisible(false)
      setPayInfo({})
      productTimer && clearInterval(productTimer)
      productTimer = null
    }
    // payType 变化且弹窗打开：切换支付方式重新获取二维码
    if (visible && prevVisibleRef.current && payType !== prevPayTypeRef.current) {
      prevPayTypeRef.current = payType
      productTimer && clearInterval(productTimer)
      productTimer = null
      setQrCodeVisible(false)
      getQrcode(payType)
    }
  })

  return (
    <Modal
      width={500}
      style={{ top: 200 }}
      footer={null}
      title='扫码付款'
      visible={qrCodeVisible}
      maskClosable={false}
      keyboard={false}
      onCancel={() => {
        setQrCodeVisible(false)
        onCancel()
      }}
    >
      <Row justify='center'>
        <p style={{ marginBottom: '0px', fontSize: '17px', color: 'gray' }}>
          您正在购买【{payInfo.productName}】服务包，数量 1/
          {payInfo.durationUnit}
        </p>
        <p style={{ fontSize: '15px', color: 'gray' }}>
          支付成功后，系统会自动处理您的订单。
        </p>
      </Row>
      <Row justify='center'>
        <Radio.Group
          value={payType}
          buttonStyle='solid'
          onChange={(e) => {
            setPayType(e.target.value)
          }}
        >
          <Radio.Button
            disabled={loading}
            value={1}
            style={{ width: 150, textAlign: 'center' }}
          >
            微信
          </Radio.Button>
          <Radio.Button
            disabled={loading}
            value={3}
            style={{ width: 150, textAlign: 'center' }}
          >
            支付宝
          </Radio.Button>
        </Radio.Group>
      </Row>
      <Row style={{ margin: '20px 0' }} justify='center'>
        <Qrcode
          value={payInfo.payCode}
          color={theme.tc1}
          size={256}
          style={{
            width: 256,
            height: 256,
          }}
        />
      </Row>
      <Row justify='center'>（ 付款金额：{payInfo.money}元 ）</Row>
    </Modal>
  )
}
